(function () {

  document.addEventListener('DOMContentLoaded', function () {

    const REQUIRED_TAG = 'sticky-enable';

    // =========================
    // LOAD FONT
    // =========================
    if (!document.getElementById('sticky-font')) {
      const link = document.createElement('link');
      link.id = 'sticky-font';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;600;700&display=swap';
      document.head.appendChild(link);
    }

    // =========================
    // INJECT CSS (YOUR STYLE)
    // =========================
    if (!document.getElementById('sticky-cart-style')) {
      const style = document.createElement('style');
      style.id = 'sticky-cart-style';

      style.innerHTML = `
        #sticky-cart {
          position: fixed;
          bottom: -100px;
          left: 0;
          width: 100%;
          background: #ffffff;
          color: #111;
          z-index: 9999!important;
          box-shadow: 0 -5px 20px rgba(0,0,0,0.08);
          transition: all 0.4s ease;
          padding: 0 16px;
          border-top: 1px solid #eee;
        }

        #sticky-cart.show {
          bottom: 0;
        }

        .sticky-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px 0;
          max-width: 900px;
          margin: 0 auto;
        }

        .sticky-left {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 1;
        }

        #sticky-image {
          width: 62px;
          height: 62px;
          object-fit: cover;
          border-radius: 6px;
          border: 1px solid #eee;
        }

        .sticky-title {
          font-size: 21px;
          font-weight: 600;
          line-height: 1.2;
          color: #111;
          font-family: 'Oswald', sans-serif;
        }

        #sticky-add {
          background: #c92a2a;
          border: none;
          padding: 12px 18px;
          border-radius: 10px;
          color: #fff;
          font-weight: 700;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.25s ease;
          font-family: 'Oswald', sans-serif;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        #sticky-add:hover {
          background: #a61e1e;
          transform: translateY(-1px);
        }

        @media (max-width: 600px) {
          #sticky-cart { padding: 0 16px; }
          .sticky-inner { padding: 10px 0; gap: 10px; }
          .sticky-title { font-size: 16px; }
          #sticky-add {
            padding: 12px 16px;
            font-size: 14px;
            border-radius: 8px;
          }
        }

        @media (min-width: 1024px) {
          .sticky-inner { max-width: 1000px; }
          #sticky-add {
            padding: 18px 42px;
            font-size: 16px;
            border-radius: 12px;
          }
        }
      `;

      document.head.appendChild(style);
    }

    // =========================
    // CREATE HTML
    // =========================
    if (!document.getElementById('sticky-cart')) {
      document.body.insertAdjacentHTML('beforeend', `
        <div id="sticky-cart">
          <div class="sticky-inner">
            <div class="sticky-left">
              <img id="sticky-image" src="" alt="">
              <div class="sticky-title">Loading...</div>
            </div>
            <button id="sticky-add">Add to Cart</button>
          </div>
        </div>
      `);
    }

    const sticky = document.getElementById('sticky-cart');
    const titleEl = document.querySelector('.sticky-title');
    const imageEl = document.getElementById('sticky-image');
    const btn = document.getElementById('sticky-add');

    if (!sticky) return;

    // =========================
    // ONLY PRODUCT PAGE
    // =========================
    if (!window.location.pathname.includes('/products/')) {
      sticky.style.display = 'none';
      return;
    }

    // =========================
    // FETCH PRODUCT
    // =========================
    fetch(window.location.pathname + '.js')
      .then(res => res.json())
      .then(product => {

        if (!product.tags || !product.tags.includes(REQUIRED_TAG)) {
          sticky.style.display = 'none';
          return;
        }

        // =========================
        // 🎯 URL-BASED TITLE OVERRIDE
        // =========================
        const url = window.location.pathname.toLowerCase();

        let customTitle = product.title;

        const titleMap = {
          'pure-stallion-v2': 'Pure Stallion',
          'pure-stallion-v3': 'Pure Stallion',
          'shred-cut-v2' : 'Shred Cut'
        };

        for (const key in titleMap) {
          if (url.includes(key)) {
            customTitle = titleMap[key];
            break;
          }
        }

        // APPLY
        titleEl.textContent = customTitle;

        // IMAGE
        imageEl.src = product.featured_image || product.images?.[0] || '';

      })
      .catch(() => {
        sticky.style.display = 'none';
      });

    // =========================
    // SHOW ON SCROLL
    // =========================
    window.addEventListener('scroll', function () {
      if (window.scrollY > 800) {
        sticky.classList.add('show');
      } else {
        sticky.classList.remove('show');
      }
    });

    // =========================
    // BUTTON CLICK
    // =========================
    btn.addEventListener('click', function () {

      const bundle = document.getElementById('prvw__bundle_container');

      if (bundle) {
        const offset = 120;
        const top = bundle.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

    });

  });

})();